if ( typeof window !== 'undefined' ) {
  if ( !window['__REKA__'] ) {
    window['__REKA__'] = {};
  }
  
  window['__REKA__']["@rekajs/types"] = "0.1.24";
}
  

import { getRandomId, invariant } from '@rekajs/utils';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var Validator = /** @class */ (function () {
    function Validator(is) {
        this.is = is;
    }
    Validator.prototype.get = function (value, opts) {
        try {
            var bool = true;
            if (this.validate) {
                bool = this.validate(value);
            }
            if (bool === false) {
                throw new Error('Invalid type');
            }
            if (!this.format) {
                return value;
            }
            return this.format(value, opts);
        }
        catch (err) {
            throw new TypeError("Validatation<".concat(this.is, "> failed for value \"").concat(JSON.stringify(value, null, 2), "\""));
        }
    };
    return Validator;
}());

var SchemaRegistry = Object.create(null);
var getTypeSchema = function (type) { return SchemaRegistry[type]; };

var Type = /** @class */ (function () {
    function Type(type, json, options) {
        var _this = this;
        var opts = __assign({ clone: false }, (options !== null && options !== void 0 ? options : {}));
        this.type = type;
        // Reuse the id specified in the JSON value
        // if cloning.replaceExistingId is not explicitly set to `true`
        if ((json === null || json === void 0 ? void 0 : json.id) &&
            (opts.clone === false ||
                opts.clone === true ||
                opts.clone.replaceExistingId === false)) {
            this.id = json.id;
        }
        else {
            this.id = getRandomId();
        }
        var definition = getTypeSchema(this.type);
        invariant(!!definition, "Schema definition not found for type \"".concat(this.type, "\""));
        definition.fields.forEach(function (field) {
            _this[field.name] = field.type.get(json === null || json === void 0 ? void 0 : json[field.name], opts);
        });
    }
    return Type;
}());

var NodeTreeSymbol = Symbol('RekaNodeTree');
/**
 * @internal
 */
var Tree = /** @class */ (function () {
    function Tree(id, root) {
        this.id = id;
        this.root = root;
    }
    Tree.prototype.addNodeToTree = function (node) {
        Tree.setNodeTree(node, this);
    };
    Tree.getNodeTree = function (node) {
        return node[NodeTreeSymbol];
    };
    Tree.setNodeTree = function (node, tree) {
        var existingNodeTree = Tree.getNodeTree(node);
        // Don't allow nodes to be used across multiple tree, as it can lead to bugs
        if (existingNodeTree) {
            invariant(existingNodeTree === tree, "".concat(node.type, "<").concat(node.id, "> is already part of a different Tree<").concat(existingNodeTree.id, ">."));
        }
        node[NodeTreeSymbol] = tree;
    };
    return Tree;
}());

var TypeValidator = /** @class */ (function (_super) {
    __extends(TypeValidator, _super);
    function TypeValidator(type, validateFn) {
        var _this = _super.call(this, 'type') || this;
        _this.type = type;
        _this.validateFn = validateFn;
        return _this;
    }
    TypeValidator.prototype.validate = function (value) {
        if (value === null && this.type === 'null') {
            return true;
        }
        if (value === 'Record') {
            return Object.getPrototypeOf(value) === Object.prototype;
        }
        var isValid = typeof value === this.type.toLowerCase();
        if (!this.validateFn) {
            return isValid;
        }
        return this.validateFn(value);
    };
    return TypeValidator;
}(Validator));
var DefaultValidator = /** @class */ (function (_super) {
    __extends(DefaultValidator, _super);
    function DefaultValidator(validator, defaultValue) {
        var _this = _super.call(this, 'default') || this;
        _this.type = validator;
        _this.defaultValue = defaultValue;
        return _this;
    }
    DefaultValidator.prototype.format = function (value, opts) {
        return this.type.get(value === undefined ? this.defaultValue : value, opts);
    };
    return DefaultValidator;
}(Validator));
var NodeValidator = /** @class */ (function (_super) {
    __extends(NodeValidator, _super);
    function NodeValidator(node, isRef) {
        var _this = _super.call(this, 'node') || this;
        _this.node = node;
        _this.isRef = isRef !== undefined ? isRef : false;
        return _this;
    }
    NodeValidator.prototype.validate = function (value) {
        if (value.type === this.node) {
            return true;
        }
        // Check if matching alias
        var schema = getTypeSchema(value.type);
        if (schema.alias && schema.alias.indexOf(this.node) > -1) {
            return true;
        }
        var nodeSchema = getTypeSchema(this.node);
        if (nodeSchema.abstract &&
            schema.ctor.prototype instanceof nodeSchema.ctor) {
            return true;
        }
        return false;
    };
    NodeValidator.prototype.format = function (value, opts) {
        if (value instanceof Type && !opts.clone) {
            return value;
        }
        var schema = getTypeSchema(value['type']);
        return schema.create(value, opts);
    };
    return NodeValidator;
}(Validator));
var UnionValidator = /** @class */ (function (_super) {
    __extends(UnionValidator, _super);
    function UnionValidator(validators) {
        var _this = _super.call(this, 'union') || this;
        _this.union = validators;
        return _this;
    }
    UnionValidator.prototype.format = function (value, opts) {
        for (var i = 0; i < this.union.length; i++) {
            try {
                return this.union[i].get(value, opts);
            }
            catch (err) {
                if (i < this.union.length - 1) {
                    continue;
                }
                throw new TypeError('No matching field types');
            }
        }
    };
    return UnionValidator;
}(Validator));
var ArrayValidator = /** @class */ (function (_super) {
    __extends(ArrayValidator, _super);
    function ArrayValidator(validator) {
        var _this = _super.call(this, 'array') || this;
        _this.array = validator;
        return _this;
    }
    ArrayValidator.prototype.validate = function (value) {
        return Array.isArray(value);
    };
    ArrayValidator.prototype.format = function (value, opts) {
        var _this = this;
        return value.map(function (v) { return _this.array.get(v, opts); });
    };
    return ArrayValidator;
}(Validator));
var MapValidator = /** @class */ (function (_super) {
    __extends(MapValidator, _super);
    function MapValidator(validator) {
        var _this = _super.call(this, 'map') || this;
        _this.type = validator;
        return _this;
    }
    MapValidator.prototype.format = function (value, opts) {
        var _this = this;
        return Object.entries(value).reduce(function (accum, _a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], value = _c[1];
            return (__assign(__assign({}, accum), (_b = {}, _b[key] = _this.type.get(value, opts), _b)));
        }, {});
    };
    return MapValidator;
}(Validator));
var ModelValidator = /** @class */ (function (_super) {
    __extends(ModelValidator, _super);
    function ModelValidator(model) {
        var _this = _super.call(this, 'model') || this;
        _this.model = model;
        return _this;
    }
    ModelValidator.prototype.format = function (value, opts) {
        var _this = this;
        return Object.keys(this.model).reduce(function (accum, key) {
            var _a;
            if (!_this.model[key]) {
                throw new TypeError('Invalid key in model');
            }
            return __assign(__assign({}, accum), (_a = {}, _a[key] = _this.model[key].get(value[key], opts), _a));
        }, {});
    };
    return ModelValidator;
}(Validator));
var ConstantValidator = /** @class */ (function (_super) {
    __extends(ConstantValidator, _super);
    function ConstantValidator(value) {
        var _this = _super.call(this, 'constant') || this;
        _this.value = value;
        return _this;
    }
    ConstantValidator.prototype.validate = function (value) {
        return value === this.value;
    };
    return ConstantValidator;
}(Validator));
var AnyValidator = /** @class */ (function (_super) {
    __extends(AnyValidator, _super);
    function AnyValidator() {
        return _super.call(this, 'any') || this;
    }
    AnyValidator.prototype.validate = function () {
        return true;
    };
    return AnyValidator;
}(Validator));

var type = function (type, validate) {
    return new TypeValidator(type, validate);
};
var node = function (node, isRef) {
    return new NodeValidator(node, isRef);
};
var union = function () {
    var validators = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        validators[_i] = arguments[_i];
    }
    return new UnionValidator(validators);
};
var array = function (validator) { return new ArrayValidator(validator); };
var optional = function (validator) {
    return new DefaultValidator(union(validator, nullish), null);
};
var map = function (validator) { return new MapValidator(validator); };
var model = function (model) {
    return new ModelValidator(model);
};
var constant = function (value) { return new ConstantValidator(value); };
var enumeration = function () {
    var constants = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        constants[_i] = arguments[_i];
    }
    return union.apply(void 0, __spreadArray([], __read(constants.map(function (c) { return constant(c); })), false));
};
var defaultValue = function (validator, defaultValue) {
    return new DefaultValidator(validator, defaultValue);
};
var any = new AnyValidator();
var string$1 = type('string');
var number = type('number');
var boolean = type('boolean');
var nullish = type('null');
var undefinedValue = type('undefined');
var func$1 = type('Function');

var assertions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    type: type,
    node: node,
    union: union,
    array: array,
    optional: optional,
    map: map,
    model: model,
    constant: constant,
    enumeration: enumeration,
    defaultValue: defaultValue,
    any: any,
    string: string$1,
    number: number,
    boolean: boolean,
    nullish: nullish,
    undefinedValue: undefinedValue,
    func: func$1
});

/**
 * Annotations are used to specify getter/computed properties on a Type
 */
var Annotation = /** @class */ (function () {
    function Annotation(name, validator) {
        this.name = name;
        this.type = optional(validator);
    }
    Annotation.prototype.get = function (node, field) {
        var value = this.compute(node, field);
        return this.type.get(value, {
            clone: false,
        });
    };
    return Annotation;
}());

/**
 * Specify that a computed field on a Type should be resolved by it's parent Tree
 */
var ResolvePropAnnotation = /** @class */ (function (_super) {
    __extends(ResolvePropAnnotation, _super);
    function ResolvePropAnnotation(validator) {
        return _super.call(this, 'resolve-prop', validator) || this;
    }
    ResolvePropAnnotation.prototype.compute = function (node, field) {
        var tree = Tree.getNodeTree(node);
        if (!tree) {
            return null;
        }
        return tree.resolveProp(node, field);
    };
    return ResolvePropAnnotation;
}(Annotation));

var resolveProp = function (validator) {
    return new ResolvePropAnnotation(validator);
};

var annotations = /*#__PURE__*/Object.freeze({
    __proto__: null,
    resolveProp: resolveProp
});

var Schema = /** @class */ (function () {
    function Schema(type, opts) {
        var _a, _b;
        this.type = type;
        this.ownFields = [];
        this.scope = false;
        this.extends = null;
        this.abstract = false;
        this.alias = [];
        this.ownFields = opts.fields
            ? Object.entries(opts.fields(assertions)).reduce(function (accum, _a) {
                var _b = __read(_a, 2), name = _b[0], type = _b[1];
                return __spreadArray(__spreadArray([], __read(accum), false), [{ name: name, type: type }], false);
            }, [])
            : [];
        this.scope = opts.scope || false;
        this.extends = opts.extends || null;
        this.abstract = opts.abstract || false;
        this.alias = opts.alias;
        this.annotations = (_b = (_a = opts.annotations) === null || _a === void 0 ? void 0 : _a.call(opts, annotations, assertions)) !== null && _b !== void 0 ? _b : {};
    }
    Object.defineProperty(Schema.prototype, "fields", {
        get: function () {
            var _this = this;
            var extendedFields = this.extends
                ? Schema.get(this.extends).fields.filter(function (field) {
                    return !_this.ownFields.find(function (ownField) { return ownField.name === field.name; });
                })
                : [];
            return __spreadArray(__spreadArray([], __read(extendedFields), false), __read(this.ownFields), false);
        },
        enumerable: false,
        configurable: true
    });
    Schema.prototype.getField = function (key, value) {
        return this.fields[key].get(value);
    };
    Schema.prototype.create = function (value, opts) {
        return new this.ctor(value, opts);
    };
    Schema.define = function (type, properties) {
        var builder = new Schema(type, properties);
        SchemaRegistry[type] = builder;
        return builder;
    };
    Schema.register = function (type, ctor) {
        SchemaRegistry[type].ctor = ctor;
    };
    Schema.get = function (type) {
        return SchemaRegistry[type];
    };
    Schema.fromJSON = function (json, opts) {
        var type = json.type;
        var schema = Schema.get(type);
        if (!type) {
            return;
        }
        return new schema.ctor(json, opts);
    };
    Schema.getRegistry = function () {
        return SchemaRegistry;
    };
    Schema.computeAnnotatedProp = function (node, prop) {
        var schema = Schema.get(node.type);
        var annotation = schema.annotations[prop];
        return annotation.get(node, prop);
    };
    return Schema;
}());

Schema.define('State', {
    fields: function (t) { return ({
        program: t.node('Program'),
        extensions: t.defaultValue(t.map(t.node('ExtensionState')), {}),
    }); },
});
Schema.define('ASTNode', {
    abstract: true,
    fields: function (t) { return ({
        meta: t.defaultValue(t.map(t.any), {}),
    }); },
});
Schema.define('Program', {
    extends: 'ASTNode',
    scope: true,
    fields: function (t) { return ({
        globals: t.defaultValue(t.array(t.node('Val')), []),
        components: t.defaultValue(t.array(t.node('RekaComponent')), []),
    }); },
});
Schema.define('Kind', {
    abstract: true,
});
Schema.define('AnyKind', {
    extends: 'Kind',
});
Schema.define('StringKind', {
    extends: 'Kind',
});
Schema.define('NumberKind', {
    extends: 'Kind',
    fields: function (t) { return ({
        min: t.optional(t.number),
        max: t.optional(t.number),
    }); },
});
Schema.define('BooleanKind', {
    extends: 'Kind',
});
Schema.define('ArrayKind', {
    extends: 'Kind',
    fields: function (t) { return ({
        elements: t.node('Kind'),
    }); },
});
Schema.define('OptionKind', {
    extends: 'Kind',
    fields: function (t) { return ({
        options: t.map(t.string),
    }); },
});
Schema.define('CustomKind', {
    extends: 'Kind',
    fields: function (t) { return ({
        name: t.string,
    }); },
});
Schema.define('Expression', {
    extends: 'ASTNode',
    abstract: true,
});
Schema.define('Identifiable', {
    extends: 'ASTNode',
    abstract: true,
    fields: function (t) { return ({
        name: t.string,
    }); },
});
Schema.define('Variable', {
    extends: 'Identifiable',
    abstract: true,
    fields: function (t) { return ({
        kind: t.defaultValue(t.node('Kind'), {
            type: 'AnyKind',
        }),
        init: t.optional(t.node('Expression')),
    }); },
});
Schema.define('Literal', {
    extends: 'Expression',
    fields: function (t) { return ({
        value: t.union(t.string, t.number, t.boolean),
    }); },
});
Schema.define('String', {
    extends: 'Expression',
    fields: function (t) { return ({
        value: t.array(t.union(t.string, t.node('Expression'))),
    }); },
});
Schema.define('Identifier', {
    extends: 'Expression',
    fields: function (t) { return ({
        name: t.string,
        external: t.defaultValue(t.boolean, false),
    }); },
    annotations: function (a, t) { return ({
        identifiable: a.resolveProp(t.node('Identifiable')),
    }); },
});
Schema.define('Val', {
    extends: 'Variable',
});
Schema.define('ArrayExpression', {
    extends: 'Expression',
    fields: function (t) { return ({
        elements: t.array(t.node('Expression')),
    }); },
});
Schema.define('BinaryExpression', {
    extends: 'Expression',
    fields: function (t) { return ({
        left: t.node('Expression'),
        operator: t.enumeration('+', '-', '*', '/', '!=', '==', '<', '<=', '>', '>=', '||', '&&', '??', '^', '%'),
        right: t.node('Expression'),
    }); },
});
Schema.define('ArrayExpression', {
    extends: 'Expression',
    fields: function (t) { return ({
        elements: t.array(t.node('Expression')),
    }); },
});
Schema.define('ObjectExpression', {
    extends: 'Expression',
    fields: function (t) { return ({
        properties: t.map(t.node('Expression')),
    }); },
});
Schema.define('Block', {
    extends: 'Expression',
    fields: function (t) { return ({
        statements: t.array(t.node('Expression')),
    }); },
});
Schema.define('Param', {
    extends: 'Identifiable',
});
Schema.define('Func', {
    extends: 'Expression',
    fields: function (t) { return ({
        name: t.defaultValue(t.union(t.string, t.nullish), null),
        params: t.array(t.node('Param')),
        body: t.node('Block'),
    }); },
});
Schema.define('CallExpression', {
    extends: 'Expression',
    fields: function (t) { return ({
        identifier: t.node('Identifier'),
        arguments: t.defaultValue(t.array(t.node('Expression')), []),
    }); },
});
Schema.define('UnaryExpression', {
    extends: 'Expression',
    fields: function (t) { return ({
        operator: t.union(t.enumeration('-', '+')),
        argument: t.node('Expression'),
    }); },
});
Schema.define('ConditionalExpression', {
    extends: 'Expression',
    fields: function (t) { return ({
        condition: t.node('Expression'),
        consequent: t.node('Expression'),
        alternate: t.node('Expression'),
    }); },
});
Schema.define('IfStatement', {
    extends: 'Expression',
    fields: function (t) { return ({
        condition: t.node('Expression'),
        consequent: t.node('Block'),
    }); },
});
Schema.define('Assignment', {
    extends: 'Expression',
    alias: ['Statement'],
    fields: function (t) { return ({
        left: t.union(t.node('Identifier'), t.node('MemberExpression')),
        operator: t.enumeration('=', '+=', '-=', '*=', '/=', '^=', '%='),
        right: t.node('Expression'),
    }); },
});
Schema.define('MemberExpression', {
    extends: 'Expression',
    fields: function (t) { return ({
        object: t.union(t.node('Identifier'), t.node('MemberExpression')),
        property: t.node('Expression'),
    }); },
});
Schema.define('ComponentProp', {
    extends: 'Variable',
    fields: function (t) { return ({
        bindable: t.defaultValue(t.boolean, false),
    }); },
});
Schema.define('Component', {
    extends: 'Identifiable',
    abstract: true,
});
Schema.define('RekaComponent', {
    extends: 'Component',
    fields: function (t) { return ({
        template: t.defaultValue(t.union(t.nullish, t.node('Template')), null),
        state: t.array(t.node('Val')),
        props: t.array(t.node('ComponentProp')),
    }); },
});
Schema.define('ExternalComponent', {
    extends: 'Component',
    fields: function (t) { return ({
        render: t.any,
        props: t.defaultValue(t.array(t.node('ComponentProp')), []),
    }); },
});
Schema.define('PropBinding', {
    extends: 'Expression',
    fields: function (t) { return ({
        identifier: t.node('Identifier'),
    }); },
});
Schema.define('Template', {
    extends: 'ASTNode',
    abstract: true,
    fields: function (t) { return ({
        props: t.defaultValue(t.map(t.node('Expression')), {}),
        if: t.defaultValue(t.union(t.node('Expression'), t.nullish), null),
        each: t.defaultValue(t.union(t.node('ElementEach'), t.nullish), null),
        classList: t.defaultValue(t.union(t.node('ObjectExpression'), t.nullish), null),
    }); },
});
Schema.define('SlottableTemplate', {
    abstract: true,
    extends: 'Template',
    fields: function (t) { return ({
        children: t.defaultValue(t.array(t.node('Template')), []),
        slots: t.defaultValue(t.map(t.array(t.node('Template'))), {}),
    }); },
});
Schema.define('FragmentTemplate', {
    abstract: true,
    extends: 'SlottableTemplate',
});
Schema.define('RootTemplate', {
    extends: 'FragmentTemplate',
});
Schema.define('TagTemplate', {
    extends: 'SlottableTemplate',
    fields: function (t) { return ({
        tag: t.string,
    }); },
});
Schema.define('ComponentTemplate', {
    extends: 'SlottableTemplate',
    fields: function (t) { return ({
        component: t.node('Identifier'),
    }); },
});
Schema.define('SlotTemplate', {
    extends: 'Template',
    fields: function (t) { return ({
        name: t.optional(t.string),
        accepts: t.optional(t.node('Identifier')),
    }); },
});
Schema.define('ElementEachAlias', {
    extends: 'Identifiable',
});
Schema.define('ElementEachIndex', {
    extends: 'Identifiable',
});
Schema.define('ElementEach', {
    extends: 'ASTNode',
    fields: function (t) { return ({
        alias: t.node('ElementEachAlias'),
        index: t.defaultValue(t.union(t.node('ElementEachIndex'), t.nullish), null),
        iterator: t.node('Expression'),
    }); },
});
Schema.define('View', {
    abstract: true,
    fields: function (t) { return ({
        key: t.string,
        template: t.node('Template', true),
        frame: t.string,
        owner: t.defaultValue(t.union(t.node('ComponentView'), t.nullish), null),
    }); },
});
Schema.define('SlottableView', {
    abstract: true,
    extends: 'View',
    fields: function (t) { return ({
        children: t.defaultValue(t.array(t.node('View')), []),
    }); },
});
Schema.define('TagView', {
    extends: 'SlottableView',
    fields: function (t) { return ({
        tag: t.string,
        props: t.map(t.any),
        bindings: t.map(t.func),
    }); },
});
Schema.define('ComponentView', {
    abstract: true,
    extends: 'SlottableView',
    fields: function (t) { return ({
        component: t.node('Component'),
    }); },
});
Schema.define('FragmentView', {
    extends: 'SlottableView',
});
Schema.define('FrameView', {
    extends: 'SlottableView',
});
Schema.define('RekaComponentView', {
    extends: 'ComponentView',
    fields: function (t) { return ({
        component: t.node('RekaComponent'),
        render: t.array(t.node('View')),
    }); },
});
Schema.define('ExternalComponentView', {
    extends: 'ComponentView',
    fields: function (t) { return ({
        component: t.node('ExternalComponent'),
        props: t.map(t.any),
    }); },
});
Schema.define('SlotView', {
    extends: 'View',
    fields: function (t) { return ({
        children: t.array(t.node('View')),
    }); },
});
Schema.define('SystemView', {
    abstract: true,
    extends: 'View',
});
Schema.define('EachSystemView', {
    extends: 'SystemView',
    fields: function (t) { return ({
        children: t.array(t.node('View')),
    }); },
});
Schema.define('ErrorSystemView', {
    extends: 'SystemView',
    fields: function (t) { return ({
        error: t.string,
    }); },
});
Schema.define('ExtensionState', {
    fields: function (t) { return ({
        value: t.union(t.nullish, t.map(t.any)),
    }); },
});
Schema.define('ExternalState', {
    extends: 'Identifiable',
    fields: function (t) { return ({
        init: t.any,
    }); },
});
Schema.define('ExternalFunc', {
    extends: 'Identifiable',
    fields: function (t) { return ({
        func: t.func,
    }); },
});

var State = /** @class */ (function (_super) {
    __extends(State, _super);
    function State(value, opts) {
        return _super.call(this, 'State', value, opts) || this;
    }
    return State;
}(Type));
Schema.register('State', State);
var ASTNode = /** @class */ (function (_super) {
    __extends(ASTNode, _super);
    function ASTNode(type, value, opts) {
        return _super.call(this, type, value, opts) || this;
    }
    return ASTNode;
}(Type));
Schema.register('ASTNode', ASTNode);
var Program = /** @class */ (function (_super) {
    __extends(Program, _super);
    function Program(value, opts) {
        return _super.call(this, 'Program', value, opts) || this;
    }
    return Program;
}(ASTNode));
Schema.register('Program', Program);
var Kind = /** @class */ (function (_super) {
    __extends(Kind, _super);
    function Kind(type, value, opts) {
        return _super.call(this, type, value, opts) || this;
    }
    return Kind;
}(Type));
Schema.register('Kind', Kind);
var AnyKind = /** @class */ (function (_super) {
    __extends(AnyKind, _super);
    function AnyKind(opts) {
        return _super.call(this, 'AnyKind', opts) || this;
    }
    return AnyKind;
}(Kind));
Schema.register('AnyKind', AnyKind);
var StringKind = /** @class */ (function (_super) {
    __extends(StringKind, _super);
    function StringKind(opts) {
        return _super.call(this, 'StringKind', opts) || this;
    }
    return StringKind;
}(Kind));
Schema.register('StringKind', StringKind);
var NumberKind = /** @class */ (function (_super) {
    __extends(NumberKind, _super);
    function NumberKind(value, opts) {
        return _super.call(this, 'NumberKind', value, opts) || this;
    }
    return NumberKind;
}(Kind));
Schema.register('NumberKind', NumberKind);
var BooleanKind = /** @class */ (function (_super) {
    __extends(BooleanKind, _super);
    function BooleanKind(opts) {
        return _super.call(this, 'BooleanKind', opts) || this;
    }
    return BooleanKind;
}(Kind));
Schema.register('BooleanKind', BooleanKind);
var ArrayKind = /** @class */ (function (_super) {
    __extends(ArrayKind, _super);
    function ArrayKind(value, opts) {
        return _super.call(this, 'ArrayKind', value, opts) || this;
    }
    return ArrayKind;
}(Kind));
Schema.register('ArrayKind', ArrayKind);
var OptionKind = /** @class */ (function (_super) {
    __extends(OptionKind, _super);
    function OptionKind(value, opts) {
        return _super.call(this, 'OptionKind', value, opts) || this;
    }
    return OptionKind;
}(Kind));
Schema.register('OptionKind', OptionKind);
var CustomKind = /** @class */ (function (_super) {
    __extends(CustomKind, _super);
    function CustomKind(value, opts) {
        return _super.call(this, 'CustomKind', value, opts) || this;
    }
    return CustomKind;
}(Kind));
Schema.register('CustomKind', CustomKind);
var Expression = /** @class */ (function (_super) {
    __extends(Expression, _super);
    function Expression(type, value, opts) {
        return _super.call(this, type, value, opts) || this;
    }
    return Expression;
}(ASTNode));
Schema.register('Expression', Expression);
var Identifiable = /** @class */ (function (_super) {
    __extends(Identifiable, _super);
    function Identifiable(type, value, opts) {
        return _super.call(this, type, value, opts) || this;
    }
    return Identifiable;
}(ASTNode));
Schema.register('Identifiable', Identifiable);
var Variable = /** @class */ (function (_super) {
    __extends(Variable, _super);
    function Variable(type, value, opts) {
        return _super.call(this, type, value, opts) || this;
    }
    return Variable;
}(Identifiable));
Schema.register('Variable', Variable);
var Literal = /** @class */ (function (_super) {
    __extends(Literal, _super);
    function Literal(value, opts) {
        return _super.call(this, 'Literal', value, opts) || this;
    }
    return Literal;
}(Expression));
Schema.register('Literal', Literal);
var String$1 = /** @class */ (function (_super) {
    __extends(String, _super);
    function String(value, opts) {
        return _super.call(this, 'String', value, opts) || this;
    }
    return String;
}(Expression));
Schema.register('String', String$1);
var Identifier = /** @class */ (function (_super) {
    __extends(Identifier, _super);
    function Identifier(value, opts) {
        return _super.call(this, 'Identifier', value, opts) || this;
    }
    Object.defineProperty(Identifier.prototype, "identifiable", {
        get: function () {
            return Schema.computeAnnotatedProp(this, 'identifiable');
        },
        enumerable: false,
        configurable: true
    });
    return Identifier;
}(Expression));
Schema.register('Identifier', Identifier);
var Val = /** @class */ (function (_super) {
    __extends(Val, _super);
    function Val(value, opts) {
        return _super.call(this, 'Val', value, opts) || this;
    }
    return Val;
}(Variable));
Schema.register('Val', Val);
var ArrayExpression = /** @class */ (function (_super) {
    __extends(ArrayExpression, _super);
    function ArrayExpression(value, opts) {
        return _super.call(this, 'ArrayExpression', value, opts) || this;
    }
    return ArrayExpression;
}(Expression));
Schema.register('ArrayExpression', ArrayExpression);
var BinaryExpression = /** @class */ (function (_super) {
    __extends(BinaryExpression, _super);
    function BinaryExpression(value, opts) {
        return _super.call(this, 'BinaryExpression', value, opts) || this;
    }
    return BinaryExpression;
}(Expression));
Schema.register('BinaryExpression', BinaryExpression);
var ObjectExpression = /** @class */ (function (_super) {
    __extends(ObjectExpression, _super);
    function ObjectExpression(value, opts) {
        return _super.call(this, 'ObjectExpression', value, opts) || this;
    }
    return ObjectExpression;
}(Expression));
Schema.register('ObjectExpression', ObjectExpression);
var Block = /** @class */ (function (_super) {
    __extends(Block, _super);
    function Block(value, opts) {
        return _super.call(this, 'Block', value, opts) || this;
    }
    return Block;
}(Expression));
Schema.register('Block', Block);
var Param = /** @class */ (function (_super) {
    __extends(Param, _super);
    function Param(value, opts) {
        return _super.call(this, 'Param', value, opts) || this;
    }
    return Param;
}(Identifiable));
Schema.register('Param', Param);
var Func = /** @class */ (function (_super) {
    __extends(Func, _super);
    function Func(value, opts) {
        return _super.call(this, 'Func', value, opts) || this;
    }
    return Func;
}(Expression));
Schema.register('Func', Func);
var CallExpression = /** @class */ (function (_super) {
    __extends(CallExpression, _super);
    function CallExpression(value, opts) {
        return _super.call(this, 'CallExpression', value, opts) || this;
    }
    return CallExpression;
}(Expression));
Schema.register('CallExpression', CallExpression);
var UnaryExpression = /** @class */ (function (_super) {
    __extends(UnaryExpression, _super);
    function UnaryExpression(value, opts) {
        return _super.call(this, 'UnaryExpression', value, opts) || this;
    }
    return UnaryExpression;
}(Expression));
Schema.register('UnaryExpression', UnaryExpression);
var ConditionalExpression = /** @class */ (function (_super) {
    __extends(ConditionalExpression, _super);
    function ConditionalExpression(value, opts) {
        return _super.call(this, 'ConditionalExpression', value, opts) || this;
    }
    return ConditionalExpression;
}(Expression));
Schema.register('ConditionalExpression', ConditionalExpression);
var IfStatement = /** @class */ (function (_super) {
    __extends(IfStatement, _super);
    function IfStatement(value, opts) {
        return _super.call(this, 'IfStatement', value, opts) || this;
    }
    return IfStatement;
}(Expression));
Schema.register('IfStatement', IfStatement);
var Assignment = /** @class */ (function (_super) {
    __extends(Assignment, _super);
    function Assignment(value, opts) {
        return _super.call(this, 'Assignment', value, opts) || this;
    }
    return Assignment;
}(Expression));
Schema.register('Assignment', Assignment);
var MemberExpression = /** @class */ (function (_super) {
    __extends(MemberExpression, _super);
    function MemberExpression(value, opts) {
        return _super.call(this, 'MemberExpression', value, opts) || this;
    }
    return MemberExpression;
}(Expression));
Schema.register('MemberExpression', MemberExpression);
var ComponentProp = /** @class */ (function (_super) {
    __extends(ComponentProp, _super);
    function ComponentProp(value, opts) {
        return _super.call(this, 'ComponentProp', value, opts) || this;
    }
    return ComponentProp;
}(Variable));
Schema.register('ComponentProp', ComponentProp);
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component(type, value, opts) {
        return _super.call(this, type, value, opts) || this;
    }
    return Component;
}(Identifiable));
Schema.register('Component', Component);
var RekaComponent = /** @class */ (function (_super) {
    __extends(RekaComponent, _super);
    function RekaComponent(value, opts) {
        return _super.call(this, 'RekaComponent', value, opts) || this;
    }
    return RekaComponent;
}(Component));
Schema.register('RekaComponent', RekaComponent);
var ExternalComponent = /** @class */ (function (_super) {
    __extends(ExternalComponent, _super);
    function ExternalComponent(value, opts) {
        return _super.call(this, 'ExternalComponent', value, opts) || this;
    }
    return ExternalComponent;
}(Component));
Schema.register('ExternalComponent', ExternalComponent);
var PropBinding = /** @class */ (function (_super) {
    __extends(PropBinding, _super);
    function PropBinding(value, opts) {
        return _super.call(this, 'PropBinding', value, opts) || this;
    }
    return PropBinding;
}(Expression));
Schema.register('PropBinding', PropBinding);
var Template = /** @class */ (function (_super) {
    __extends(Template, _super);
    function Template(type, value, opts) {
        return _super.call(this, type, value, opts) || this;
    }
    return Template;
}(ASTNode));
Schema.register('Template', Template);
var SlottableTemplate = /** @class */ (function (_super) {
    __extends(SlottableTemplate, _super);
    function SlottableTemplate(type, value, opts) {
        return _super.call(this, type, value, opts) || this;
    }
    return SlottableTemplate;
}(Template));
Schema.register('SlottableTemplate', SlottableTemplate);
var FragmentTemplate = /** @class */ (function (_super) {
    __extends(FragmentTemplate, _super);
    function FragmentTemplate(type, value, opts) {
        return _super.call(this, type, value, opts) || this;
    }
    return FragmentTemplate;
}(SlottableTemplate));
Schema.register('FragmentTemplate', FragmentTemplate);
var RootTemplate = /** @class */ (function (_super) {
    __extends(RootTemplate, _super);
    function RootTemplate(value, opts) {
        return _super.call(this, 'RootTemplate', value, opts) || this;
    }
    return RootTemplate;
}(FragmentTemplate));
Schema.register('RootTemplate', RootTemplate);
var TagTemplate = /** @class */ (function (_super) {
    __extends(TagTemplate, _super);
    function TagTemplate(value, opts) {
        return _super.call(this, 'TagTemplate', value, opts) || this;
    }
    return TagTemplate;
}(SlottableTemplate));
Schema.register('TagTemplate', TagTemplate);
var ComponentTemplate = /** @class */ (function (_super) {
    __extends(ComponentTemplate, _super);
    function ComponentTemplate(value, opts) {
        return _super.call(this, 'ComponentTemplate', value, opts) || this;
    }
    return ComponentTemplate;
}(SlottableTemplate));
Schema.register('ComponentTemplate', ComponentTemplate);
var SlotTemplate = /** @class */ (function (_super) {
    __extends(SlotTemplate, _super);
    function SlotTemplate(value, opts) {
        return _super.call(this, 'SlotTemplate', value, opts) || this;
    }
    return SlotTemplate;
}(Template));
Schema.register('SlotTemplate', SlotTemplate);
var ElementEachAlias = /** @class */ (function (_super) {
    __extends(ElementEachAlias, _super);
    function ElementEachAlias(value, opts) {
        return _super.call(this, 'ElementEachAlias', value, opts) || this;
    }
    return ElementEachAlias;
}(Identifiable));
Schema.register('ElementEachAlias', ElementEachAlias);
var ElementEachIndex = /** @class */ (function (_super) {
    __extends(ElementEachIndex, _super);
    function ElementEachIndex(value, opts) {
        return _super.call(this, 'ElementEachIndex', value, opts) || this;
    }
    return ElementEachIndex;
}(Identifiable));
Schema.register('ElementEachIndex', ElementEachIndex);
var ElementEach = /** @class */ (function (_super) {
    __extends(ElementEach, _super);
    function ElementEach(value, opts) {
        return _super.call(this, 'ElementEach', value, opts) || this;
    }
    return ElementEach;
}(ASTNode));
Schema.register('ElementEach', ElementEach);
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View(type, value, opts) {
        return _super.call(this, type, value, opts) || this;
    }
    return View;
}(Type));
Schema.register('View', View);
var SlottableView = /** @class */ (function (_super) {
    __extends(SlottableView, _super);
    function SlottableView(type, value, opts) {
        return _super.call(this, type, value, opts) || this;
    }
    return SlottableView;
}(View));
Schema.register('SlottableView', SlottableView);
var TagView = /** @class */ (function (_super) {
    __extends(TagView, _super);
    function TagView(value, opts) {
        return _super.call(this, 'TagView', value, opts) || this;
    }
    return TagView;
}(SlottableView));
Schema.register('TagView', TagView);
var ComponentView = /** @class */ (function (_super) {
    __extends(ComponentView, _super);
    function ComponentView(type, value, opts) {
        return _super.call(this, type, value, opts) || this;
    }
    return ComponentView;
}(SlottableView));
Schema.register('ComponentView', ComponentView);
var FragmentView = /** @class */ (function (_super) {
    __extends(FragmentView, _super);
    function FragmentView(value, opts) {
        return _super.call(this, 'FragmentView', value, opts) || this;
    }
    return FragmentView;
}(SlottableView));
Schema.register('FragmentView', FragmentView);
var FrameView = /** @class */ (function (_super) {
    __extends(FrameView, _super);
    function FrameView(value, opts) {
        return _super.call(this, 'FrameView', value, opts) || this;
    }
    return FrameView;
}(SlottableView));
Schema.register('FrameView', FrameView);
var RekaComponentView = /** @class */ (function (_super) {
    __extends(RekaComponentView, _super);
    function RekaComponentView(value, opts) {
        return _super.call(this, 'RekaComponentView', value, opts) || this;
    }
    return RekaComponentView;
}(ComponentView));
Schema.register('RekaComponentView', RekaComponentView);
var ExternalComponentView = /** @class */ (function (_super) {
    __extends(ExternalComponentView, _super);
    function ExternalComponentView(value, opts) {
        return _super.call(this, 'ExternalComponentView', value, opts) || this;
    }
    return ExternalComponentView;
}(ComponentView));
Schema.register('ExternalComponentView', ExternalComponentView);
var SlotView = /** @class */ (function (_super) {
    __extends(SlotView, _super);
    function SlotView(value, opts) {
        return _super.call(this, 'SlotView', value, opts) || this;
    }
    return SlotView;
}(View));
Schema.register('SlotView', SlotView);
var SystemView = /** @class */ (function (_super) {
    __extends(SystemView, _super);
    function SystemView(type, value, opts) {
        return _super.call(this, type, value, opts) || this;
    }
    return SystemView;
}(View));
Schema.register('SystemView', SystemView);
var EachSystemView = /** @class */ (function (_super) {
    __extends(EachSystemView, _super);
    function EachSystemView(value, opts) {
        return _super.call(this, 'EachSystemView', value, opts) || this;
    }
    return EachSystemView;
}(SystemView));
Schema.register('EachSystemView', EachSystemView);
var ErrorSystemView = /** @class */ (function (_super) {
    __extends(ErrorSystemView, _super);
    function ErrorSystemView(value, opts) {
        return _super.call(this, 'ErrorSystemView', value, opts) || this;
    }
    return ErrorSystemView;
}(SystemView));
Schema.register('ErrorSystemView', ErrorSystemView);
var ExtensionState = /** @class */ (function (_super) {
    __extends(ExtensionState, _super);
    function ExtensionState(value, opts) {
        return _super.call(this, 'ExtensionState', value, opts) || this;
    }
    return ExtensionState;
}(Type));
Schema.register('ExtensionState', ExtensionState);
var ExternalState = /** @class */ (function (_super) {
    __extends(ExternalState, _super);
    function ExternalState(value, opts) {
        return _super.call(this, 'ExternalState', value, opts) || this;
    }
    return ExternalState;
}(Identifiable));
Schema.register('ExternalState', ExternalState);
var ExternalFunc = /** @class */ (function (_super) {
    __extends(ExternalFunc, _super);
    function ExternalFunc(value, opts) {
        return _super.call(this, 'ExternalFunc', value, opts) || this;
    }
    return ExternalFunc;
}(Identifiable));
Schema.register('ExternalFunc', ExternalFunc);

var state = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = State).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var program = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = Program).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var anyKind = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = AnyKind).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var stringKind = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = StringKind).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var numberKind = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = NumberKind).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var booleanKind = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = BooleanKind).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var arrayKind = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = ArrayKind).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var optionKind = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = OptionKind).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var customKind = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = CustomKind).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var literal = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = Literal).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var string = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = String$1).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var identifier = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = Identifier).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var val = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = Val).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var arrayExpression = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = ArrayExpression).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var binaryExpression = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = BinaryExpression).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var objectExpression = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = ObjectExpression).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var block = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = Block).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var param = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = Param).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var func = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = Func).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var callExpression = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = CallExpression).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var unaryExpression = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = UnaryExpression).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var conditionalExpression = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = ConditionalExpression).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var ifStatement = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = IfStatement).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var assignment = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = Assignment).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var memberExpression = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = MemberExpression).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var componentProp = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = ComponentProp).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var rekaComponent = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = RekaComponent).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var externalComponent = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = ExternalComponent).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var propBinding = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = PropBinding).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var rootTemplate = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = RootTemplate).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var tagTemplate = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = TagTemplate).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var componentTemplate = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = ComponentTemplate).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var slotTemplate = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = SlotTemplate).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var elementEachAlias = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = ElementEachAlias).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var elementEachIndex = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = ElementEachIndex).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var elementEach = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = ElementEach).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var tagView = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = TagView).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var fragmentView = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = FragmentView).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var frameView = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = FrameView).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var rekaComponentView = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = RekaComponentView).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var externalComponentView = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = ExternalComponentView).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var slotView = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = SlotView).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var eachSystemView = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = EachSystemView).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var errorSystemView = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = ErrorSystemView).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var extensionState = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = ExtensionState).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var externalState = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = ExternalState).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};
var externalFunc = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = ExternalFunc).bind.apply(_a, __spreadArray([void 0], __read(args), false)))();
};

/**
 * Match a callback to a Type
 */
var match = function (node, visitor) {
    var currentType = node.type;
    // eslint-disable-next-line no-constant-condition
    while (true) {
        if (visitor[currentType]) {
            return visitor[currentType](node);
        }
        var schema = Schema.get(currentType);
        if (schema.extends) {
            currentType = schema.extends;
            continue;
        }
        break;
    }
};
var isObjectLiteral = function (t) {
    return !!t && 'object' === typeof t && t.constructor === Object;
};
var toJS = function (value) {
    if (typeof value === 'function' || !(value instanceof Object)) {
        return value;
    }
    if (Array.isArray(value)) {
        return value.map(function (c) { return toJS(c); });
    }
    if (isObjectLiteral(value)) {
        return Object.keys(value).reduce(function (accum, key) {
            var _a;
            return (__assign(__assign({}, accum), (_a = {}, _a[key] = toJS(value[key]), _a)));
        }, {});
    }
    if (value instanceof Type) {
        var Ctor = value.constructor;
        return new Ctor(value);
    }
    throw new Error();
};
/**
 * Compare 2 Types and merge differences
 */
var merge = function (a, b, opts) {
    var getOpt = function (type) {
        var _a, _b, _c, _d, _e;
        var schema = Schema.get(type);
        var cascadedOpt = schema.extends ? getOpt(schema.extends) : null;
        var exclude = ((_b = (_a = opts === null || opts === void 0 ? void 0 : opts.types) === null || _a === void 0 ? void 0 : _a[type]) === null || _b === void 0 ? void 0 : _b.exclude) || [];
        var diff = (_d = (_c = opts === null || opts === void 0 ? void 0 : opts.types) === null || _c === void 0 ? void 0 : _c[type]) === null || _d === void 0 ? void 0 : _d.diff;
        return {
            exclude: __spreadArray(__spreadArray([], __read(exclude), false), __read(((_e = cascadedOpt === null || cascadedOpt === void 0 ? void 0 : cascadedOpt.exclude) !== null && _e !== void 0 ? _e : [])), false).filter(function (value, index, self) { return self.indexOf(value) === index; }),
            diff: function (a, b) {
                var o;
                if (cascadedOpt === null || cascadedOpt === void 0 ? void 0 : cascadedOpt.diff) {
                    o = cascadedOpt.diff(a, b);
                }
                if (o !== undefined) {
                    return o;
                }
                if (diff) {
                    o = diff(a, b);
                }
                if (o !== undefined) {
                    return o;
                }
            },
        };
    };
    var mergeValue = function (a, b) {
        var e_1, _a;
        if (a === b) {
            return a;
        }
        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length > b.length) {
                a.splice(b.length);
            }
            for (var i = 0; i < a.length; i++) {
                var mergedElement = mergeValue(a[i], b[i]);
                if (a[i] === mergedElement) {
                    continue;
                }
                a[i] = mergedElement;
            }
            for (var i = a.length; i < b.length; i++) {
                a.push(b[i]);
            }
            return a;
        }
        if (a instanceof Type && b instanceof Type) {
            if (a.type !== b.type) {
                return b;
            }
            var options = getOpt(a.type);
            var diffed = options.diff(a, b);
            if (diffed !== undefined) {
                return diffed;
            }
            var fields = Schema.get(a.type).fields;
            try {
                for (var fields_1 = __values(fields), fields_1_1 = fields_1.next(); !fields_1_1.done; fields_1_1 = fields_1.next()) {
                    var field = fields_1_1.value;
                    if (options.exclude.includes(field.name)) {
                        continue;
                    }
                    var newValue = mergeValue(a[field.name], b[field.name]);
                    if (a[field.name] !== newValue) {
                        a[field.name] = newValue;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (fields_1_1 && !fields_1_1.done && (_a = fields_1.return)) _a.call(fields_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return a;
        }
        if (isObjectLiteral(a) && isObjectLiteral(b)) {
            for (var key in b) {
                if (a[key]) {
                    var t_1 = mergeValue(a[key], b[key]);
                    a[key] = t_1;
                    continue;
                }
                a[key] = b[key];
            }
            for (var key in a) {
                if (b[key] !== undefined) {
                    continue;
                }
                delete a[key];
            }
            return a;
        }
        if (typeof a === 'function' && typeof b === 'function' && (opts === null || opts === void 0 ? void 0 : opts.function)) {
            var diff = opts.function(a, b);
            if (diff !== undefined) {
                return diff;
            }
        }
        return b;
    };
    return mergeValue(a, b);
};
/**
 * Flatten a Type and its children
 */
var flatten = function (root) {
    var types = {};
    var convert = function (value) {
        if (!value) {
            return value;
        }
        if (Array.isArray(value)) {
            return value.map(function (c) { return convert(c); });
        }
        if (typeof value === 'object') {
            var obj = Object.entries(value).reduce(function (accum, _a) {
                var _b;
                var _c = __read(_a, 2), k = _c[0], v = _c[1];
                return __assign(__assign({}, accum), (_b = {}, _b[k] = convert(v), _b));
            }, {});
            if (value instanceof Type) {
                types[value.id] = obj;
                return {
                    $$typeId: value.id,
                };
            }
            return obj;
        }
        return value;
    };
    var flattenRoot = convert(root);
    return {
        types: types,
        root: flattenRoot,
    };
};
/**
 * Restore a flattend Type
 */
var unflatten = function (flattenedType) {
    var root = flattenedType.root, types = flattenedType.types;
    var convert = function (value) {
        if (!value) {
            return value;
        }
        if (Array.isArray(value)) {
            return value.map(function (child) { return convert(child); });
        }
        if (typeof value === 'object') {
            var obj = value;
            var isType = false;
            if (value['$$typeId']) {
                obj = types[value['$$typeId']];
                isType = true;
            }
            var transformedObj = Object.entries(obj).reduce(function (accum, _a) {
                var _b;
                var _c = __read(_a, 2), key = _c[0], child = _c[1];
                return __assign(__assign({}, accum), (_b = {}, _b[key] = convert(child), _b));
            }, {});
            if (isType) {
                return Schema.fromJSON(transformedObj);
            }
            return transformedObj;
        }
        return value;
    };
    return convert(root);
};
/**
 * Collect all child Types within a given Type
 */
var collect = function (type) {
    var types = [];
    var collect = function (value) {
        if (!value) {
            return;
        }
        if (Array.isArray(value)) {
            value.forEach(function (c) { return collect(c); });
            return;
        }
        if (typeof value === 'object') {
            if (value instanceof Type) {
                types.push(value);
            }
            Object.keys(value).forEach(function (key) {
                collect(value[key]);
            });
            return;
        }
    };
    collect(type);
    return types;
};
var is = function (value, type) {
    return value instanceof type;
};
function assert(value, assertedType, cb) {
    if (!is(value, assertedType)) {
        throw new Error("Invalid type. Expected type ".concat(assertedType.name, " but received ").concat(is(value, Type) ? value.type : typeof value));
    }
    if (cb) {
        return cb(value);
    }
    return value;
}
var getRootIdentifierInMemberExpression = function (expr) {
    if (is(expr.object, Identifier)) {
        return expr.object;
    }
    return getRootIdentifierInMemberExpression(expr.object);
};
/**
 * Clone a primitive value, object literal or a Reka data type
 */
var clone = function (value, options) {
    var opts = __assign({ replaceExistingId: false }, (options !== null && options !== void 0 ? options : {}));
    if (is(value, Type)) {
        return Schema.fromJSON(value, {
            clone: {
                replaceExistingId: opts.replaceExistingId,
            },
        });
    }
    if (Array.isArray(value)) {
        return value.map(function (item) { return clone(item, opts); });
    }
    if (isObjectLiteral(value)) {
        return Object.keys(value).reduce(function (accum, key) {
            var _a;
            return __assign(__assign({}, accum), (_a = {}, _a[key] = clone(value[key], opts), _a));
        }, {});
    }
    return value;
};
var toStringType = function (node) {
    if (is(node, String$1)) {
        return node;
    }
    return string({
        value: [node],
    });
};
/**
 * Given an array of Type instances, check if they are all the same Type
 */
var isSameType = function (nodes) {
    if (nodes.length === 1) {
        return true;
    }
    for (var i = 1; i < nodes.length; i++) {
        var prev = nodes[i - 1];
        var current = nodes[i];
        if (prev.type !== current.type) {
            return false;
        }
    }
    return true;
};

export { ASTNode, AnyKind, AnyValidator, ArrayExpression, ArrayKind, ArrayValidator, Assignment, BinaryExpression, Block, BooleanKind, CallExpression, Component, ComponentProp, ComponentTemplate, ComponentView, ConditionalExpression, ConstantValidator, CustomKind, DefaultValidator, EachSystemView, ElementEach, ElementEachAlias, ElementEachIndex, ErrorSystemView, Expression, ExtensionState, ExternalComponent, ExternalComponentView, ExternalFunc, ExternalState, FragmentTemplate, FragmentView, FrameView, Func, Identifiable, Identifier, IfStatement, Kind, Literal, MapValidator, MemberExpression, ModelValidator, NodeValidator, NumberKind, ObjectExpression, OptionKind, Param, Program, PropBinding, RekaComponent, RekaComponentView, RootTemplate, Schema, SlotTemplate, SlotView, SlottableTemplate, SlottableView, State, String$1 as String, StringKind, SystemView, TagTemplate, TagView, Template, Tree, Type, TypeValidator, UnaryExpression, UnionValidator, Val, Validator, Variable, View, anyKind, arrayExpression, arrayKind, assert, assertions, assignment, binaryExpression, block, booleanKind, callExpression, clone, collect, componentProp, componentTemplate, conditionalExpression, customKind, eachSystemView, elementEach, elementEachAlias, elementEachIndex, errorSystemView, extensionState, externalComponent, externalComponentView, externalFunc, externalState, flatten, fragmentView, frameView, func, getRootIdentifierInMemberExpression, identifier, ifStatement, is, isObjectLiteral, isSameType, literal, match, memberExpression, merge, numberKind, objectExpression, optionKind, param, program, propBinding, rekaComponent, rekaComponentView, rootTemplate, slotTemplate, slotView, state, string, stringKind, tagTemplate, tagView, toJS, toStringType, unaryExpression, unflatten, val };
